import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { ActiveToast } from 'components/layout'
import { ACTIVITY_STATES } from 'constants/enums'

export default class ActivityToasts extends Component {
  static propTypes = {
    onOpenAssessorApproval: PropTypes.func,
    onOpenLeaderApproval: PropTypes.func,
    onResendAssessmentRequest: PropTypes.func,
    activity: PropTypes.object
  }

  render() {
    const {
      activity,
      onOpenAssessorApproval,
      onResendAssessmentRequest,
      onOpenLeaderApproval
    } = this.props

    const completedPercentage = get(activity, 'completedPercentage')
    const activityState = get(activity, 'activityState.value')
    const isAssessmentPositive = get(activity, 'isAssessmentPositive')

    const showAssessRequestToast =
      get(activity, 'canBeSentForAssessment') === true
    const showLeaderRequestToast = get(activity, 'canBeSentForSignoff') === true
    const showAssessWaitingToast =
      ACTIVITY_STATES.assessment.id === activityState &&
      completedPercentage === 100 &&
      !isAssessmentPositive
    const showLeaderWaitingToast =
      ACTIVITY_STATES.award_leader_singoff.id === activityState &&
      completedPercentage === 100

    return (
      <div>
        <ActiveToast
          text="You can send now your Activity to Assessor for approval."
          intlKey="label.you_can_send_activity_for_approval"
          action="Send"
          actionKey="button.send"
          onClick={onOpenAssessorApproval}
          toShow={showAssessRequestToast}
        />
        <ActiveToast
          text="You can send now your Activity to Award Leader for approval."
          intlKey="label.you_can_send_activity_for_leader"
          action="Send"
          actionKey="button.send"
          onClick={onOpenLeaderApproval}
          toShow={showLeaderRequestToast}
        />
        <ActiveToast
          text="Waiting for award leader sign-off."
          intlKey="label.waiting_for_sign_off"
          toShow={showLeaderWaitingToast}
          noBtn
        />
        <ActiveToast
          text="Waiting for assessor approval"
          intlKey="notifications.waiting_for_assessor_approval"
          action="Resend assessment request"
          actionKey="button.resend_assessment_request"
          toShow={showAssessWaitingToast}
          onClick={onResendAssessmentRequest}
        />
      </div>
    )
  }
}
